<template>
  <div class="events-wrap">
    <!-- <div class="events-title">{{ $t('landing.think.title') }}</div> -->
    <div class="events-view-all">
      <span>{{ $t('landing.think.title.desc') }}</span>
    </div>

    <ul class="events-list">
      <li v-for="(item, index) in list" :key="index">
        <div class="events-list-icon">
          <img :src="item.icon" alt />
        </div>
        <div class="events-list-wrap">
          <div class="events-list-title">
            {{ item.title }}<span v-if="item.subText" style="font-size:11px;">{{ ' ' + item.subText }}</span>
          </div>
          <!-- <div class="events-list-desc">{{item.desc}}</div> -->
          <div class="events-list-btn d-flex align-center justify-space-between">
            <a @click="redirectTo(item.flag, item.redirectLink)">{{ item.btn }}</a>
            <img @click="redirectTo(item.flag, item.redirectLink)" :src="require('@/assets/images/home/go_to.png')" alt />
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<style scoped>
.events-wrap {
  margin: 0 auto;
  padding-bottom: 65px;
}
.events-title {
  color: #fff;
  font-size: 30px;
  text-align: center;
}
.events-view-all {
  font-size: 30px;
  color: #fff;
  text-align: center;
  /* padding: 0 15px; */
  padding: 65px 15px 0px;
}
.events-list-wrap {
  width: 100%;
}
.events-list {
  padding: 30px 20px 0px !important;
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex-wrap: wrap;
}
.events-list > li {
  display: flex;
  align-items: flex-start;
  padding: 40px 22px;
  background-color: #fff;
  border-radius: 10px;
  margin: 0 16px;
  flex-basis: 460px;
  margin-top: 20px;
}
.events-list-icon {
  /* flex: 0 0 74px; */
  margin-right: 15px;
}
.events-list-title {
  font-size: 16px;
  font-weight: bold;
  color: rgba(85, 85, 85, 1);
  padding-bottom: 6px;
}
.events-list-desc {
  font-size: 14px;
  color: rgba(85, 85, 85, 1);
  padding-bottom: 25px;
}

.events-list-btn a {
  color: inherit;
}

.events-list-btn {
  font-size: 14px;
  font-weight: bold;
  line-height: 19px;
  color: rgba(30, 73, 172, 1);
  opacity: 1;
  cursor: pointer;
  user-select: none;
}
.events-list-btn img {
  margin-left: 10px;
}

@media screen and (max-width: 576px) {
  .events-wrap {
    padding-bottom: 45px;
  }

  .events-title {
    padding-top: 45px;
  }

  .events-list > li {
    padding: 30px 22px;
  }
}
</style>
<script>
export default {
  name: 'Banner',
  components: {},
  data() {
    return {
      currentCoin: 'GRX',
      list: [
        {
          icon: require('@/assets/images/home/thingk_over_1.png'),
          title: this.$t('landing.think.sec.1'),
          // subText: this.$t('landing.think.sec.1.coming'),
          btn: this.$t('landing.think.desc.1'),
          flag: 1,
          redirectLink: 'affiliate'
          // desc: 'Leverage on our sophisticated IB platform structure to potentially grow your market',
        }
        /*{
          icon: require('@/assets/images/home/thingk_over_2.png'),
          title: this.$t('landing.think.sec.2'),
          btn: this.$t('landing.think.desc.2'),
          flag: 2,
          redirectLink: this.$t('links.fees'),
          // desc: 'Leverage on our sophisticated IB platform structure to potentially grow your market',
        },*/
      ]
    };
  },
  methods: {
    redirectTo(flag, link) {
      if (flag === 1) {
        this.$router.replace({ name: link });
      } else if (flag === 2) {
        window.open(link, '_blank'); // Temporarily disable
      }
    }
  }
};
</script>
